import React, { useCallback, useEffect, useState } from 'react';
import { Button, Text } from '@mantine/core';

import { ConfirmModal } from '../../common/ConfirmModal';
import { usePricingBatchStaging } from './PricingBatchStagingContext';

export function PricingBatchStagedSubmitButton() {
    const { queuedCount, submitAllQueued, submitting } =
        usePricingBatchStaging();

    const [submitConfirmOpened, setSubmitConfirmOpened] = useState(false);

    useEffect(() => {
        if (submitConfirmOpened && queuedCount === 0) {
            setSubmitConfirmOpened(false);
        }
    }, [submitConfirmOpened, queuedCount]);

    const handleOpenConfirm = useCallback(() => {
        if (queuedCount === 0 || submitting) {
            return;
        }
        setSubmitConfirmOpened(true);
    }, [queuedCount, submitting]);

    const closeSubmitConfirm = useCallback(() => {
        setSubmitConfirmOpened(false);
    }, []);

    const label =
        queuedCount === 0
            ? 'Submit queued actions'
            : `Submit queued actions (${queuedCount})`;

    return (
        <>
            <Button
                type="button"
                variant="filled"
                color="primary"
                size="sm"
                loading={submitting}
                disabled={queuedCount === 0 || submitting}
                onClick={handleOpenConfirm}
                classNames={{
                    root: 'w-fit shrink-0',
                    label: 'text-white font-medium whitespace-nowrap',
                }}
            >
                {label}
            </Button>

            <ConfirmModal
                opened={submitConfirmOpened}
                onClose={closeSubmitConfirm}
                title="Submit queued price change actions?"
                confirmLabel="Submit"
                cancelLabel="Cancel"
                onConfirm={submitAllQueued}
                loading={submitting}
            >
                <Text size="sm" c="dark.7">
                    Are you sure you want to submit{' '}
                    {queuedCount === 1
                        ? 'this queued price change action'
                        : `these ${queuedCount} queued price change actions`}
                    ? Each action runs on the server in sequence.
                </Text>
            </ConfirmModal>
        </>
    );
}
